import { Grid } from '@mui/material';
import { useTheme } from '@mui/system';
import useShowCurrency from 'framework/base/hooks/useShowCurrency';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import React, { useEffect, useRef, useState } from 'react';
import ArySelectablePinnedTable from './ArySelectablePinnedTable';
import AryTable from './AryTable';

const ArySelectableTable = ({
  data,
  columns,
  filteredColumnsList,
  pinnedColumnsList,
  noContentBox,
  customNoContent,
  isFlat,
  page,
  pageCount,
  tableSx,
  onHover,
  handleChangeStatistics,
  isTableSelectable,
  rowBackgroundCondition,
  selectedTransactions
}) => {
  const { t } = useFrameworkTranslation();
  const langDirection = t('dir');
  const tableRef = useRef(null);
  const theme = useTheme();
  const showCurrency = useShowCurrency();
  const popOverRef = useRef(null);
  const stickyHeadSx = {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.table.header.color,
    zIndex: 1
  };
  /** ******************************* states ************************************* */
  const [clickedRowIndex, setClickedRowIndex] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [invalidCalculationColumns, setInvalidCalculationColumns] = useState(
    []
  );

  /** ******************************* states ************************************* */

  /** ******************************* functions ************************************* */
  const isAnyDifferentCol = (cols) => {
    let result = true;
    if (cols) {
      const firstColumn = cols?.[0];
      result = cols.find((col) => col !== firstColumn);
    }
    return result;
  };
  const handlePopoverOpen = (
    rowIndex,
    columnIndex,
    Rows,
    Cols,
    invalidCols
  ) => {
    if (
      !isAnyDifferentCol(Cols) &&
      (rowIndex || rowIndex === 0) &&
      (columnIndex || columnIndex === 0) &&
      invalidCols.length !== Cols.length
    ) {
      setSelectedRows(Rows);
      setSelectedColumns(Cols);
      setInvalidCalculationColumns(invalidCols);
    } else {
      setSelectedRows([]);
      setSelectedColumns([]);
      setInvalidCalculationColumns([]);
    }
  };

  const toCamelCase = (str) =>
    str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, '');

  const handleCalculation = (calculationKey) => {
    if (!calculationKey) return;

    const objField = toCamelCase(calculationKey);
    const statistics = {};

    const getCurrencyCode = (row) => {
      const rowData = data[row];
      const currencyMap = {
        OutgoingAmount: rowData.draftCurrencyTitle,
        IncomingAmount: rowData.draftCurrencyTitle,
        CommissionAmount:
          rowData.commissionCurrencyTitle ||
          showCurrency({ code: rowData.commissionCurrencyCode }) ||
          rowData.currencyTitle,
        EquivalentAmount:
          rowData.equivalentCurrencyTitle ||
          showCurrency({ code: rowData.equivalentCurrencyCode }),
        Debtor:
          rowData.currencyTitle || showCurrency({ code: rowData.currencyCode }),
        Creditor:
          rowData.currencyTitle || showCurrency({ code: rowData.currencyCode }),
        Withdraw:
          rowData.currencyTitle || showCurrency({ code: rowData.currencyCode }),
        Deposit:
          rowData.currencyTitle || showCurrency({ code: rowData.currencyCode }),
        Commission:
          rowData.currencyTitle || showCurrency({ code: rowData.currencyCode }),
        DraftAmount:
          rowData.draftCurrencyTitle ||
          showCurrency({ code: rowData.draftCurrencyCode }),
        draftCommissionAmount: rowData.draftCommissionCurrency,
        receivedMoneyAmount: rowData.receivedMoneyCurrencyTitle
      };

      return currencyMap[calculationKey] || '';
    };

    selectedRows.forEach((row) => {
      const code = getCurrencyCode(row);
      const value = Number(data[row][objField]);
      if (!code) return;
      if (!statistics[code]) {
        statistics[code] = { sum: { value: 0, label: t('table.sum') } };
      }

      statistics[code].sum.value += value;
    });

    statistics.show = true;
    handleChangeStatistics(statistics);
  };
  useEffect(() => {
    if (selectedColumns?.length !== invalidCalculationColumns?.length) {
      selectedColumns?.forEach((column) => {
        if (!invalidCalculationColumns.includes(column)) {
          handleCalculation(filteredColumnsList[column]);
        }
      });
    }
  }, [selectedColumns?.length, invalidCalculationColumns?.length]);
  /** ******************************* functions ************************************* */

  return (
    <>
      <Grid
        container
        style={{
          flexDirection: langDirection === 'rtl' ? 'row-reverse' : 'row',
          height: '100%'
        }}
      >
        <Grid
          item
          flexGrow={1}
          sx={{
            display: filteredColumnsList.length ? null : 'none'
          }}
        >
          <AryTable
            ref={tableRef}
            popOverRef={popOverRef}
            data={data}
            columns={columns}
            filteredColumnsList={filteredColumnsList}
            pinnedColumnsList={pinnedColumnsList}
            noContentBox={noContentBox}
            customNoContent={customNoContent}
            isFlat={isFlat}
            page={page}
            pageCount={pageCount}
            rowBackgroundCondition={rowBackgroundCondition}
            selectedTransactions={selectedTransactions}
            tableSx={tableSx}
            onHover={onHover}
            handlePopoverOpen={handlePopoverOpen}
            isTableSelectable={isTableSelectable}
            handleResetStatistics={() => handleChangeStatistics({})}
          />
        </Grid>
        {pinnedColumnsList !== undefined && pinnedColumnsList.length > 0 && (
          <Grid item flexGrow={1}>
            <ArySelectablePinnedTable
              handleChangeStatistics={handleChangeStatistics}
              pinnedColumnsList={pinnedColumnsList}
              noContentBox={noContentBox}
              customNoContent={customNoContent}
              data={data}
              columns={columns}
              tableSx={tableSx}
              stickyHeadSx={stickyHeadSx}
              onHover={onHover}
              isFlat={isFlat}
              page={Number(page)}
              pageCount={Number(pageCount)}
              clickedRowIndex={clickedRowIndex}
              setClickedRowIndex={setClickedRowIndex}
              isTableSelectable={isTableSelectable}
            />
          </Grid>
        )}
      </Grid>
      {/* <AryPopoverTableCalculation
        handleChangeCalculationKey={(newValue) => handleCalculation(newValue)}
        selectedColumns={selectedColumns}
        invalidCalculationColumns={invalidCalculationColumns}
        filteredColumns={filteredColumnsList}
      /> */}
    </>
  );
};

export default ArySelectableTable;
